import type { RouteRecordRaw } from 'vue-router';

const placeholderComponent = () => import('../views/PlaceholderPage.vue');

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'initial',
    component: () => import('../views/InitialPage.vue')
  },
  {
    path: '/gps-error',
    name: 'gps-error',
    component: placeholderComponent
  },
  {
    path: '/appointment-error',
    name: 'appointment-error',
    component: placeholderComponent
  },
  {
    path: '/warehouse-error',
    name: 'warehouse-error',
    component: placeholderComponent
  },
  {
    path: '/rejected-check-in',
    name: 'rejected-check-in',
    component: placeholderComponent
  },
  {
    path: '/completed',
    name: 'completed',
    component: () => import('../views/CheckinCompletePage.vue')
  },
  {
    path: '/verification-error',
    name: 'verification-error',
    component: () => import('../views/VerificationFailedPage.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFound.vue')
  }
];
